<template>
  <div class="test-details">
    <HeadedContainer>
      <template v-slot:header>
        {{ $ml.get(`TEST DETAILS`) }}
      </template>
      <div class="form">
        <TestDetailsTop/>
        <TestDetailsBottom/>
      </div>
    </HeadedContainer>
  </div>
</template>

<script>
import HeadedContainer from '@/components/common/HeadedContainer'
import TestDetailsTop from './TestDetailsTop';
import TestDetailsBottom from './TestDetailsBottom';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      
    }
  },
  components: {
    HeadedContainer,
    TestDetailsTop,
    TestDetailsBottom,
  },
  computed: {
    ...mapGetters({
      form: 'tests/soil/form'
    })
  },
}
</script>

<style lang="scss" scoped>

.form {
  width: 100%;
  padding-bottom: 30px;
  
  display: flex;
  flex-direction: column;
}

</style>